import { defineAction } from '~/prix'
import { z } from 'zod'
import machineServiceUpdateAction from './machineServiceUpdate.action.json' with { type: 'json' }
import { machineServiceUpdateInputObject } from '../machineServiceObject'

const machineServiceUpdateDefinition = defineAction({
  ...machineServiceUpdateAction,

  input: machineServiceUpdateInputObject,
  output: z.object({}),
})

export default machineServiceUpdateDefinition
